import type { ReactNode } from 'react';
import { Star } from 'lucide-react';
import type { HotelDetailsView } from '../models.js';
import { OfferBadge } from '../../shared/results_page/offer_badge.js';

/** O selo "Hotel com acordo" (#6359) na identidade da gaveta e da Página do
 *  Hotel — o MESMO selo do card de resultados (`offerBadges`), sem o anel, que
 *  só existe para interromper a borda do card. Sem rótulo, nada. */
export function HotelDetailsAgreementBadge({
  label,
}: {
  readonly label: string | undefined;
}): ReactNode {
  if (!label) return null;
  return (
    <span className="justify-self-start">
      <OfferBadge
        badge={{ id: 'agreed-rate', label, tone: 'within', icon: 'agreement' }}
        ring={false}
      />
    </span>
  );
}

/** A linha da nota da PÁGINA, peça a peça quando o adapter manda as partes —
 *  ★ + nota em negrito + faixa + contagem apagada (régua do protótipo,
 *  2026-08-27). Sem `valueLabel` (dado antigo/story mínima) cai na frase
 *  pronta, a mesma da gaveta. */
export function HotelDetailsPageRating({
  rating,
}: {
  readonly rating: NonNullable<HotelDetailsView['rating']>;
}) {
  if (!rating.valueLabel) {
    return (
      <p className="hui-hotel-page-rating">
        {rating.label}
        {rating.value === undefined ? '' : `: ${String(rating.value)}`}
      </p>
    );
  }
  return (
    <p className="hui-hotel-page-rating">
      <Star aria-hidden="true" />
      <strong>{rating.valueLabel}</strong>
      {rating.bandLabel && <span>{rating.bandLabel}</span>}
      {rating.reviewsLabel && (
        <span className="hui-hotel-page-rating-count">{rating.reviewsLabel}</span>
      )}
    </p>
  );
}
